'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = require('./util');

var _store = require('./store');

// 全局缓存
/**
 * model请求缓存部分处理
 * Created by spring on 2018/9/5.
 */

var store = new _store.Store('responseData');

exports.default = {
  /**
   * 对外接口，获取请求的数据缓存
   * @param url 接口地址
   * @param params 请求参数
   * @returns {any}
   */
  get: function get(url, params) {
    var defer = $.Deferred();
    var urlKey = (0, _util.encode)((0, _util.toUrlWithParams)(url, params));

    var result = store.get(urlKey);
    console.log('response cache get', url, result);
    return result ? defer.resolve(JSON.parse(result)) : defer.reject(false);
  },


  /**
   * 对外接口
   * @param url 接口地址
   * @param params 请求参数
   * @param data 缓存数据
   */
  set: function set(url, params, data) {
    var urlKey = (0, _util.encode)((0, _util.toUrlWithParams)(url, params));
    console.log('response cache set', urlKey, data);
    store.set(urlKey, JSON.stringify(data));
    return true;
  }
};